import { render, staticRenderFns } from "./ChemUCI1LCQ2S1Q2.vue?vue&type=template&id=2d152c39&scoped=true&"
import script from "./ChemUCI1LCQ2S1Q2.vue?vue&type=script&lang=js&"
export * from "./ChemUCI1LCQ2S1Q2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d152c39",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VForm,VSelect})
